import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 创建订单
export default async function orderCreate(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/create', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
